import React from "react";
import "./Features.css";
import { defaultHomeSettings, normalizeHomeSettings } from "../utils/homeContent";

function Features({ settings }) {
  const homeSettings = normalizeHomeSettings(settings || defaultHomeSettings);

  return (
    <section className="features-section">
      <div className="features-shell">
        <div className="features-copy">
          <p className="features-eyebrow">Why NIDCS</p>
          <h2 className="features-title">{homeSettings.features_section_title}</h2>
          <p className="features-subtitle">{homeSettings.features_section_subtitle}</p>
        </div>

        <div className="features-grid">
          {homeSettings.features.map((item) => (
            <div key={item.title} className="feature-card">
              <div className="feature-icon">
                <i className={`bi ${item.icon}`}></i>
              </div>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
